<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Copyright</a>
</li>
<li id="level1-front4">
<a href="#/front02">Dedication</a>
</li>
<li id="c01">
<a href="#/c01">Crash</a>
</li>
<li id="c02">
<a href="#/c02">Nap</a>
</li>
<li id="c03">
<a href="#/c03">Complaint</a>
</li>
<li id="c04">
<a href="#/c04">Canasta</a>
</li>
<li id="c05">
<span href="#/c05" title="Link target outside of Sample">Road Trip</span>
</li>
<li id="c06">
<span href="#/c06" title="Link target outside of Sample">Orientation</span>
</li>
<li id="c07">
<span href="#/c07" title="Link target outside of Sample">Turbo Cooler</span>
</li>
<li id="c08">
<span href="#/c08" title="Link target outside of Sample">Gadget</span>
</li>
<li id="c09">
<span href="#/c09" title="Link target outside of Sample">Park</span>
</li>
<li id="c10">
<span href="#/c10" title="Link target outside of Sample">Skateboard</span>
</li>
<li id="c11">
<span href="#/c11" title="Link target outside of Sample">Almost There</span>
</li>
<li id="c12">
<span href="#/c12" title="Link target outside of Sample">Meteorology</span>
</li>
<li id="c13">
<span href="#/c13" title="Link target outside of Sample">Talk Show</span>
</li>
<li id="c14">
<span href="#/c14" title="Link target outside of Sample">Scheme</span>
</li>
<li id="c15">
<span href="#/c15" title="Link target outside of Sample">Laundromat</span>
</li>
<li id="c16">
<span href="#/c16" title="Link target outside of Sample">Tara</span>
</li>
<li id="c17">
<span href="#/c17" title="Link target outside of Sample">Salad</span>
</li>
<li id="c18">
<span href="#/c18" title="Link target outside of Sample">Bump</span>
</li>
<li id="c19">
<span href="#/c19" title="Link target outside of Sample">Job Site</span>
</li>
<li id="c20">
<span href="#/c20" title="Link target outside of Sample">Fever</span>
</li>
<li id="c21">
<span href="#/c21" title="Link target outside of Sample">Crouton</span>
</li>
<li id="c22">
<span href="#/c22" title="Link target outside of Sample">Misty</span>
</li>
<li id="c23">
<span href="#/c23" title="Link target outside of Sample">Offer</span>
</li>
<li id="c24">
<span href="#/c24" title="Link target outside of Sample">Madame X</span>
</li>
<li id="c25">
<span href="#/c25" title="Link target outside of Sample">Boogeyman</span>
</li>
<li id="c26">
<span href="#/c26" title="Link target outside of Sample">Messenger</span>
</li>
<li id="c27">
<span href="#/c27" title="Link target outside of Sample">Doorbell</span>
</li>
<li id="c28">
<span href="#/c28" title="Link target outside of Sample">Famous</span>
</li>
<li id="c29">
<span href="#/c29" title="Link target outside of Sample">Lipstick</span>
</li>
<li id="c30">
<span href="#/c30" title="Link target outside of Sample">Hostage</span>
</li>
<li id="c31">
<span href="#/c31" title="Link target outside of Sample">Elves</span>
</li>
<li id="c32">
<span href="#/c32" title="Link target outside of Sample">Antarctica</span>
</li>
<li id="c33">
<span href="#/c33" title="Link target outside of Sample">Sandbox</span>
</li>
<li id="c34">
<span href="#/c34" title="Link target outside of Sample">Astronaut</span>
</li>
<li id="c35">
<span href="#/c35" title="Link target outside of Sample">One</span>
</li>
<li id="level1-back40">
<span href="#/back01" title="Link target outside of Sample">Acknowledgments</span>
</li>
<li id="level1-back41">
<span href="#/back02" title="Link target outside of Sample">About the Author</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7a6bd3ce